/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-03 11:36:02
 * @FilePath: /unifyxp-v2-store-portal/src/router/Components/Route.tsx
 */
import React from 'react';
import {
  Router as _Rer,
  Switch as _S,
  Route as _R,
  Redirect as _D,
} from 'react-router-dom';
import { ErrorBoundary } from 'src/components/ErrorBoundary';
import * as Sentry from '@sentry/react';

const Route = (props) => {
  const { children, ...rest } = props;
  return (
    <ErrorBoundary>
      <_R {...rest}>{children}</_R>
    </ErrorBoundary>
  );
};
const SentryRoute = Sentry.withSentryRouting(Route);

const Switch = (props) => {
  const { children, ...rest } = props;
  return <_S {...rest}>{children}</_S>;
};
const Router = (props) => {
  const { children, ...rest } = props;
  return <_Rer {...rest}>{children}</_Rer>;
};
const Redirect = (props) => {
  const { children, ...rest } = props;
  return <_D {...rest}>{children}</_D>;
};
export { SentryRoute as Route, Switch, Router, Redirect };
